import LeistungsseiteTemplate from "@/components/feature/LeistungsseiteTemplate";
import { allTestimonials } from "@/data/testimonials";
import speicherHeroSungrow from "@/assets/stromspeicher-hero-sungrow-neu.png";
import speicherDetail from "@/assets/stromspeicher-richtige-groesse-schwarz.png";
import speicherPanelWarum from "@/assets/stromspeicher-warum-sungrow-wechselrichter.jpg";
import speicherInstallation from "@/assets/stromspeicher-wechselrichter-montage.png";
import speicherMehrfamilienhaus from "@/assets/stromspeicher-mehrfamilienhaus-pv-dach.png";
import photovoltaikCrosslink from "@/assets/photovoltaik-efh-solaranlage.png";
import asset_stromspeicher_referenz_zweering_montage from "@/assets/stromspeicher-referenz-zweering-montage.jpg";
import Seo, { serviceSchema } from "@/components/feature/Seo";
export default function Stromspeicher() {
  return (
    <>
      <Seo
        title="Stromspeicher & Batteriespeicher | Zweering Elektrotechnik Emmerich am Rhein"
        description="Batteriespeicher für Ihre Photovoltaik-Anlage — geplant und installiert aus einer Hand vom Elektro-Meisterbetrieb in Emmerich am Rhein und Umgebung."
        canonical="https://zweering.de/stromspeicher"
        breadcrumbs={[{"name": "Startseite", "url": "https://zweering.de/"}, {"name": "Leistungen", "url": "https://zweering.de/stromspeicher"}, {"name": "Stromspeicher", "url": "https://zweering.de/stromspeicher"}]}
        schema={serviceSchema("Stromspeicher-Installation", "Auslegung, Installation und Einbindung von Batteriespeichern in bestehende und neue Photovoltaik-Anlagen in Emmerich am Rhein und Umgebung.", "https://zweering.de/stromspeicher")}
      />
      <LeistungsseiteTemplate
      label="LEISTUNGEN"
      title="STROMSPEICHER"
      subline="Ihr Solarstrom — rund um die Uhr verfügbar. Speicherlösungen geplant und installiert aus einer Hand, in Emmerich am Rhein und Umgebung."
      heroImage={speicherHeroSungrow}
      heroImageAlt="Schwarzer Stromspeicher mit grüner Status-LED an der Wand im Hauswirtschaftsraum in Emmerich am Rhein"
      leadText={
        <>
          Eine Photovoltaik-Anlage erzeugt Strom dann, wenn die Sonne scheint — nicht
          unbedingt dann, wenn Sie ihn brauchen. Ein Stromspeicher schließt diese Lücke
          und macht Sie <span className="text-[#4CAF50]">wirklich unabhängiger</span> vom
          Netz.
        </>
      }
      panels={[
        {
          title: "WARUM EIN SPEICHER?",
          body: "Ohne Speicher nutzen Sie nur einen Teil Ihres Solarstroms selbst — der Rest geht für wenig Vergütung ins Netz. Ein Speicher hebt Ihren Eigenverbrauch deutlich an.",
          image: speicherPanelWarum,
          imageAlt: "Weißer Sungrow Hybrid-Wechselrichter mit Kabelanschlüssen an der Wand im Hauswirtschaftsraum",
        },
        {
          title: (
            <>
              DIE <span className="text-[#4CAF50]">RICHTIGE GRÖSSE</span>
            </>
          ),
          body: "Wir dimensionieren den Speicher passend zu Ihrem Verbrauch und Ihrer PV-Anlage — nicht zu klein, nicht überdimensioniert, sondern wirtschaftlich sinnvoll.",
          image: speicherDetail,
          imageAlt: "Schwarzer Stromspeicher mit grüner Status-LED an der Wand im Hauswirtschaftsraum in Emmerich am Rhein",
        },
        {
          title: "SAUBERE INSTALLATION",
          body: "Anschluss, Absicherung und Einbindung ins Hausnetz durch unseren Elektro-Meisterbetrieb — fachgerecht und nach allen Normen.",
          image: speicherInstallation,
          imageAlt: "Montage eines Wechselrichters mit Kabelanschlüssen durch Zweering Elektrotechnik",
        },
        {
          title: "BEREIT FÜR MEHR",
          body: "Ihr Speicher lässt sich mit Wallbox, Smart Home und weiteren Verbrauchern zu einem ganzen Energiesystem verbinden — alles aus einer Hand.",
          image: speicherMehrfamilienhaus,
          imageAlt: "Mehrfamilienhaus mit Photovoltaik-Anlage auf dem Flachdach in Emmerich am Rhein",
        },
      ]}
      testimonials={allTestimonials}
      trustLine="Vertrauen unserer Kundinnen und Kunden am Niederrhein."
      manifest={"STROM SPEICHERN.\nUNABHÄNGIG WERDEN.\nSELBST ENTSCHEIDEN."}
      caseStudy={{
        title: "SPEICHER NACHGERÜSTET",
        text: "Bestehende PV-Anlage um einen Stromspeicher erweitert — höhere Unabhängigkeit, installiert aus einer Hand in Emmerich am Rhein und Umgebung.",
        href: "#referenzen",
        image: asset_stromspeicher_referenz_zweering_montage,
        imageAlt: "Zweering Elektrotechnik Monteur bei der Inbetriebnahme eines Sungrow Stromspeichers mit Pufferspeicher in Emmerich am Rhein",
      }}
      faq={[
        {
          frage: "Kann ich einen Speicher zu meiner bestehenden PV-Anlage nachrüsten?",
          antwort:
            "In den meisten Fällen ja. Wir prüfen Ihre Anlage und beraten Sie, welche Speicherlösung passt.",
        },
        {
          frage: "Wie groß sollte mein Speicher sein?",
          antwort:
            "Das hängt von Ihrem Verbrauch und Ihrer PV-Leistung ab. Wir dimensionieren ihn individuell — wirtschaftlich, nicht pauschal.",
        },
        {
          frage: "Habe ich mit Speicher auch bei Stromausfall Strom?",
          antwort:
            "Nur mit der passenden Technik (Ersatzstromfunktion). Ob und wie das in Ihrem Fall geht, klären wir in der Beratung.",
        },
        {
          frage: "Lohnt sich ein Speicher wirtschaftlich?",
          antwort:
            "Ein Speicher erhöht Ihren Eigenverbrauch deutlich. Ob er sich für Sie rechnet, zeigen wir Ihnen transparent in der Beratung.",
        },
      ]}
      ctaText={{
        headline: "BEREIT, IHREN STROM ZU SPEICHERN?",
        subtext: "Kostenlose Beratung — wir finden die passende Speicherlösung für Sie.",
        buttonLabel: "Erstberatung anfragen",
        buttonHref: "/kontakt",
        variant: "green",
      }}
      crossLink={{
        title: "PHOTOVOLTAIK",
        text: "Noch keine PV-Anlage? Hier beginnt Ihre eigene Energie.",
        href: "/photovoltaik",
        image: photovoltaikCrosslink,
        imageAlt: "Einfamilienhaus mit schwarzer Photovoltaik-Anlage auf dem Satteldach in Emmerich am Rhein",
      }}
    />
    </>
  );
}
